import { useTranslation } from "react-i18next";
import { Skeleton } from "@athena/ui";

/** Rows per placeholder day: enough to suggest a grouped list without filling a tall screen. */
const ROWS_PER_DAY = [
    2,
    3,
];

/**
 * The contact log while it loads, in the shape of its rows: a day label, then per contact the
 * avatar and name, channel, note, outcome, who logged it and when. Its columns come and go
 * at the same row widths as `ContactLogItem`'s.
 */
export function ContactLogSkeleton() {
    const { t } = useTranslation();

    return (
        <div role="status" aria-busy="true" aria-label={t("admin.alumni.contactLog.loading")} className="grid gap-8">
            {ROWS_PER_DAY.map((rows, day) => (
                <div key={day} className="grid gap-3">
                    <div className="flex items-center gap-3">
                        <Skeleton className="h-3 w-36" />
                        <div className="bg-border h-px flex-1" />
                    </div>
                    {Array.from({ length: rows }, (_, row) => (
                        <div key={row} className="@container">
                            <div className="border-border bg-card flex items-center gap-4 rounded-2xl border px-4 py-4 @3xl:gap-6 @3xl:px-6 @3xl:py-5">
                                <div className="flex min-w-0 flex-1 items-center gap-3 @xl:w-44 @xl:flex-none @5xl:w-56">
                                    <Skeleton className="h-8 w-8 shrink-0 rounded-full" />
                                    <Skeleton className="h-4 flex-1" />
                                </div>
                                <div className="hidden w-32 shrink-0 items-center gap-3 @4xl:flex">
                                    <Skeleton className="h-7 w-7 shrink-0 rounded-full" />
                                    <Skeleton className="h-4 flex-1" />
                                </div>
                                <Skeleton className="hidden h-4 min-w-0 flex-1 @xl:block" />
                                <Skeleton className="ml-auto h-7 w-20 shrink-0 rounded-full @xl:ml-0" />
                                <Skeleton className="hidden h-4 w-32 shrink-0 @6xl:block" />
                                <div className="hidden w-16 shrink-0 justify-end @3xl:flex">
                                    <Skeleton className="h-3 w-14" />
                                </div>
                                <Skeleton className="h-4 w-4 shrink-0" />
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
